import {CSSProperties} from "react";

import { blue300, yellowA700 } from 'material-ui/styles/colors';
export const selectedColor = blue300;
export const warningColor = yellowA700;
export const styles = {
    chip: {
      margin: 3,
    } as CSSProperties,
    footer: {
      position: 'fixed',
      bottom: '0px',
      paddingBottom: '10px',
      paddingTop: '10px',
      zIndex: 10,
      width: '90%',
      display: 'inline-flex',
      justifyContent: 'center',
      zoom: 0.8,
      maxWidth: '1750px',
      transition:
        'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    } as CSSProperties,
    regionTab: {
      minWidth: '70px',
      fontSize: '12px',
    } as CSSProperties,
    loadMoreStyleContainer: {
      margin: '10px 0px',
      textAlign: 'center',
    } as CSSProperties,
    draftLinkForm: {
        display: "grid",
        gridGap: "10px",
        gridTemplateColumns: "1fr 50px",
        gridTemplateRows: "1fr 1fr"
    } as CSSProperties,
    draftLinkText: {
        width: 'auto',
        minWidth: 'none',
        overflow: 'hidden',
        gridColumn: 1,
        gridRow: 1,
    } as CSSProperties,
    alertMessage: {
        color: '#E0B32D',
        display:'flex',
        alignItems:'flex-start',
        gridColumn: 1,
        gridRow: 2
    } as CSSProperties,
    draftCTA: {
        gridColumn: 2,
        gridRowStart: 1,
        gridRowEnd: 3,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: "30px",
    } as CSSProperties,

  };

  export default styles;


// WEBPACK FOOTER //
// ./src/pages/drafts/styles/glanceDraftsStyle.ts